import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  ModalLogoWrapper,
  ModalLogoABC,
  ModalLogoPUB,
  ModalLogoYET,
  ModalLogoFUN,
  ModalLogoCAC,
  ModalLogoHYC,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const ReviewTransactionsDialog = ({
  showModal,
  handleProceed,
  skin,
}) => {
  const { t } = useTranslation("");

  return (
    <StyledModal isOpen={Boolean(showModal)}>
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{
          __html: t("label_review_account_transactions"),
        }}
      ></StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_go_to_transactions")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
